import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss'],
})
export class ImagePreviewComponent implements OnInit {
  @Input() image:string
  @Output() close: EventEmitter<any> = new EventEmitter<any>()
  sliderOpt = {
    zoom: {
      maxRatio: 1,
    },
    allowTouchMove: false
  };
  constructor() { }

  ngOnInit() {}

  closePreview(){
    this.close.emit()
  }
}
